import React from "react";
import styled from "styled-components";

const StyledDeadlineBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.space[2]};
  border-radius: 0;
  background: linear-gradient(
    0deg,
    ${({ theme }) => theme.colors.accentRed} 60%,
    ${({ theme }) => theme.colors.accentRedTwo} 40%
  );
  font-size: ${({ theme }) => theme.fontSizes[4]};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${({ theme }) => theme.radii[1]};
  }
`;

const Heading = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  font-size: inherit;
`;

const Deadline = styled.time`
  margin-inline-start: 0.4rem;
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  font-weight: bold;
`;

interface IProps {
  deadlineISO: string;
  deadlineLocal: string;
  headingText: string;
}

const DeadlineBar: React.FC<IProps> = ({
  deadlineISO,
  deadlineLocal,
  headingText,
}) => (
  <StyledDeadlineBar>
    <Heading>{headingText}:</Heading>
    <span>&nbsp;</span>
    <Deadline dateTime={deadlineISO}>{deadlineLocal}</Deadline>
  </StyledDeadlineBar>
);

export default DeadlineBar;
